<div class="sign-up-marketing-disclaimer-footer">
  <p>
    By clicking '{{clickActionText}}', you agree to our <a
      href="https://www.fitnesspassport.com.au/privacy-policy/">Privacy Policy</a>. You’ll
    also receive occasional updates, special offers, and news from us. You can unsubscribe at any time.
  </p>
</div>